module.exports = __webpack_public_path__ + "fonts/3b9f662.eot";